let baseProfix = '';
// let baseProfix:string='/ys'
// if(process.env.NODE_ENV === 'production') {
//     baseProfix = ''
export default {
    comment: {
        getcommentlist: baseProfix + '/api/News/getRemarkList',
        postadopt: baseProfix + '/api/News/addRemarkOpiniom',
    },
    user: {
        getMyApplyList: baseProfix + '/api/dashboard/getMyApply',
        getAllApplyList: baseProfix + '/api/dashboard/getAllApply',
        addMyApply: baseProfix + '/api/dashboard/addMyApply',
        delMyApply: baseProfix + '/api/dashboard/delMyApply',
        getUserUnreadMail: baseProfix + '/api/eyou/getUserMail/unread',
        getUserMail: baseProfix + '/api/eyou/getUserMail/all',
        getUserReadMailSSOUrl: baseProfix + '/api/eyou/getUserReadMailSSOUrl',
        getFRSSOUrl: baseProfix + '/api/eyou/login/cross/domain',
        getNotifyInfo: baseProfix + '/api/dashboard/getNotifyInfo',
        sortMyApply: baseProfix + '/api/dashboard/sortMyApply',
    },
    news: {
        getSlideshow: baseProfix + '/api/news/getSlideshow',
        getNewsList: baseProfix + '/api/news/getNewsList',
        getIndexNewsList: baseProfix + '/api/news/getIndexNewsList',
        getIndexNoticesList: baseProfix + '/api/news/getIndexNoticesList',
        getNoticesList: baseProfix + '/api/news/getNoticesList',
        getLibraryType: baseProfix + '/api/Library/getTypeList',
        getLibraryTypeList: baseProfix + '/api/Library/getLeftTypeList',
        getLibraryFileList: baseProfix + '/api/Library/getLibraryList',
        getLibraryFileDetail: baseProfix + '/api/Library/getLibraryDetailById'
    },
    // workflow:{
    //     //change by baodn use baseProfix to visit server addr not localhost
    //     // getWorkitemList:baseProfix+'/api/runtime/workflow/getWorkitemList',
    //     getWorkitemList: '/api/myRuntime/workflow/getWorkitemList',///////获取待办任务 build
    //     //change end
    //     // getWorkitemFinishedList:'/api/runtime/workflow/list_finished_workitems',//已办任务
    //     getWorkitemFinishedList: '/api/myRuntime/workflow/getWorkitemFinishedList',//616更新已办任务
    //     // getWorkflow: baseProfix+'/api/runtime/workflow/list_my_workflow2',//查看所有流程
    //     listInstances:'/api/runtime/workflow/list_my_instances2',//我的流程
    //     listInstancesIndex:'/api/runtime/workflow/list_instances',//产品我的流程
    //     searchProcess:'/api/runtime/workflow/list_my_workflow_by_name',//搜索流程
    //     createFavorites:'/api/runtime/favorites/create_favorites_workflow',//收藏
    //     deleteFavorites:'/api/runtime/favorites/delete_favorites_workflow',//删除收藏
    //     getFavoritesWorkflow:'/api/runtime/favorites/list_favorites_workflow',//获取常用流程
    //     getFavoritesWorkflowsList: '/api/runtime/favorites/list_favorites_workflow',//首页获取常用流程
    //     // getFavoritesWorkflowsList: window.location.protocol + '//' + window.location.hostname+ '/api/runtime/favorite/getFavoritesWorkflowsList',//首页获取常用流程 build
    //     getByWorkcode: baseProfix +'/api/sy/workflow/getByWorkcode',//查看当前流程
    //     startWorkflow: baseProfix +'/api/runtime/form/start_workflow',//发起流程
    //     // getApprovalTabList: baseProfix + '/api/runtime/workflow/getSystemList' //获取第三方系统列表
    // },
    suggest: {
        getSurveyList: baseProfix + '/api/sy/suggest/survey/get',
    },
    // 在线服务
    online: {
        getBanners: baseProfix + '/api/news/getSlideshow',
        getCommonServices: baseProfix + '/api/sy/administration/commonService/get',
        getEnters: baseProfix + '/api/sy/administration/enterance/get',
        getQusetions: baseProfix + '/api/sy/administration/question/get',
        getNotices: baseProfix + '/api/news/getNoticesList',
        getNews: baseProfix + '/api/news/getNewsList',
        getNewDetail: baseProfix + '/api/news/getNewsDetailById',
        getNoticeDetail: baseProfix + '/api/news/getNoticeDetailById',
        doLike: baseProfix + '/api/news/addLikeNum',
        addRemark: baseProfix + '/api/news/addRemark',
        getdeleteRemark: baseProfix + '/api/news/deleteRemark'
    },
    // 菜单栏
    menu: {
        getMailCount: baseProfix + '/api/eyou/getUserMail/unread/count',
        getNavList: baseProfix + '/api/sy/navigation/getByposition',
        getMailUrl: baseProfix + '/api/eyou/getMailSSOUrl',
        searchAll: baseProfix + '/api/search/searchAll' //全站搜索接口
        // getSchedules: baseProfix + '/api/wechat/calendar/scheduleLimit2'
    },
    // 人事服务
    my: {
        getUser: baseProfix + '/api/hr/getStaffByCode',
        getUserInfos: baseProfix + '/api/organization/user/info_login',
        getCommonFlow: baseProfix + '/api/hr/getCommApplyOrService',
        getErrorInfos: baseProfix + '/api/hr/kqAbnormalQuery',
        getNewTypes: baseProfix + '/api/news/getNewsTypeList',
        getImagesEdit: baseProfix + '/api/hr/uploadUsrPhotoInfo',
        getGrowUpInfo: baseProfix + '/api/hr/getGrowUpInfo' //石药人生
    },
    //日程
    schedule: {
        // getSchedulesList: '/api/wechat/calendar/scheduleLimit2',
        addSchedule: '/api/wechat/calendar/schedule',
        updateSchedule: '/api/wechat/calendar/updateSchedule',
    },
    //应用
    app: {
        getAppList: baseProfix + '/api/dashboard/getAppList',
        getFolderList: baseProfix + '/api/dashboard/getChildAppList',
        getApprovalTabList: baseProfix + '/api/dashboard/getSystemList',
        getVersionInfo: baseProfix + '/api/dashboard/getVersionInfo' // 获取门户版本信息
    },
    //门户地图
    homeMap: {
        getHomeMapList: baseProfix + '/api/subDoor/getDoorList',
        getSubPortalData: baseProfix + '/api/subDoor/subPortalInfo',
        getModuleList: baseProfix + '/api/newSubportal/getModuleList',
        getModuleListById: baseProfix + '/api/newSubportal/getModuleListById',
        getContentDetailById: baseProfix + '/api/newSubportal/getContentDetailById',
        getWdDetailById: baseProfix + '/api/newSubportal/getWdDetailById',
    },
    //数据中心
    dataCenter: {
        getDataCenterList: baseProfix + '/api/subDoor/getDataCenterList' //获取数据中心列表
    },
    //获取头像
    userIcon: {
        getUserIcon: baseProfix + '/api/api/aliyun/download' //获取图片
    },
    //echarts
    echarts: {
        findCompany: 'http://120.24.111.201/api/api/salesReport/findCompanys',
        findSalesAmountHistogram: 'http://120.24.111.201/api/api/salesReport/findSalesAmountHistogram',
        findDeliveryAmountHistogram: "http://120.24.111.201/api/api/salesReport/findDeliveryAmountHistogram",
        findSalesDistributionPieChart: "http://120.24.111.201/api/api/salesReport/findSalesDistributionPieChart",
        findDeliveryDistributionPieChart: "http://120.24.111.201/api/api/salesReport/findDeliveryDistributionPieChart" //销售分布饼图
    },
    //绩效系统主页看板
    homeBoard: {
        getDisplayBoardWorkItemCount: baseProfix + '/api/jxgl/displayBoard/getDisplayBoardWorkItemCount',
        getSuperviseFeedbackDetails: baseProfix + '/api/jxgl/displayBoard/getSuperviseFeedbackDetails',
        getGzjdtbDetails: baseProfix + '/api/jxgl/displayBoard/getGzjdtbDetails',
        getUserManageDept: baseProfix + '/api/jxgl/displayBoard/getUserManageDept',
        getZykhsxDetails: baseProfix + '/api/jxgl/displayBoard/getZykhsxDetails' //获取专业考核事项的详情
    },
    //流程中心改版到各应用系统下
    workflowApp: {
        getWorkitemCount: baseProfix + '/api/workitemByApp/getWorkitemCount',
        getWorkflowOfApp: baseProfix + '/api/workitemByApp/getWorkflowOfApp',
        searchWorkitems: baseProfix + '/api/runtime/workflow/search_workitems',
        searchCirculates: baseProfix + '/api/runtime/workflow/search_circulates',
        listFinishedWorkitems: baseProfix + '/api/runtime/workflow/list_finished_workitems',
        listFinishedCirculates: baseProfix + '/api/runtime/workflow/list_finished_circulates',
        listMyInstances: baseProfix + '/api/runtime/workflow/list_my_instances',
    },
    //抗肿瘤流向管理
    antitumor: {
        getUserManageCompany: baseProfix + '/api/antitumorBusiness/findUserManageCom',
        getNotFrozenMonth: baseProfix + '/api/antitumorBusiness/getNotFrozenMonth',
        getTerminalNotFrozenMonth: baseProfix + '/api/antitumorBusiness/getTerminalNotFrozenMonth',
        getRegionAndAgency: baseProfix + '/api/antitumorBusiness/getRegionAndAgency',
        getCount: baseProfix + '/api/antitumorBusiness/getCount',
        getTerminalCount: baseProfix + '/api/antitumorBusiness/getTerminalCount',
        getBySchedule: baseProfix + '/api/antitumorBusiness/getBySchedule',
        getByManualVerify: baseProfix + '/api/antitumorBusiness/getByManualVerify',
        getByErrorCheck: baseProfix + '/api/antitumorBusiness/getByErrorCheck',
        getTerminalListBySchedule: baseProfix + '/api/antitumorBusiness/getTerminalListBySchedule',
        getTerminalBySystemVerify: baseProfix + '/api/antitumorBusiness/getTerminalBySystemVerify',
        getTerminalByErrorCheck: baseProfix + '/api/antitumorBusiness/getTerminalByErrorCheck',
        batchPass: baseProfix + '/api/antitumorBusiness/batchPass',
        batchFailed: baseProfix + '/api/antitumorBusiness/batchFailed',
        queryAsyncExportData: baseProfix + '/api/runtime/query/export_data/self/async',
        queryAsyncExportTerminalData: baseProfix + '/api/runtime/query/export_data/self/terminal/async',
        terminalBatchPass: baseProfix + '/api/antitumorBusiness/terminalBatchPass',
        terminalBatchFailed: baseProfix + '/api/antitumorBusiness/terminalBatchFailed',
        businessBatchOverrule: baseProfix + '/api/antitumorBusiness/businessBatchOverrule',
        terminalBatchOverrule: baseProfix + '/api/antitumorBusiness/terminalBatchOverrule',
    }
};
// export default {
//     // workflow : {
//     //     searchWorkitems : '/aaaa'
//     // },
//     // fff:{
//     //     f : 'ff'
//     // }
// };
